<template>
    <UModal :model-value="open" @update:model-value="$emit('update:open', $event)">
        <UCard :ui="{ rounded: 'rounded-lg', body: { base: 'overflow-visible' } }">
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-base font-medium leading-6 text-gray-800">
                        Call Center Preferences
                    </h3>
                    <UButton color="gray" variant="ghost" icon="i-ph-x-bold" class="-my-1" @click="dismiss()" />
                </div>
            </template>
            <div class="space-y-5">
                <UFormGroup name="device" label="Ringer Output Device">
                    <USelectMenu 
                        v-model="deviceId" 
                        :options="devices"
                        value-attribute="deviceId"
                        option-attribute="label"
                        size="lg"
                        nullable
                    />
                </UFormGroup>
                <UFormGroup name="extension" label="Extension">
                    <UInput 
                        v-model="extension" 
                        type="number"
                        size="lg"
                        nullable
                    />
                </UFormGroup>
            </div>
            <template #footer>
                <div class="flex items-center justify-end space-x-2">
                    <UButton @click="dismiss()" size="lg" color="white">
                        Cancel
                    </UButton>
                    <UButton @click="confirm()" size="lg" color="black">
                        Save
                    </UButton>
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
const emit = defineEmits<{
    'update:open': [boolean]
}>()

const props = defineProps<{
    open: boolean
}>()

const { fetchExtensionStatus, getPreferences, updatePreferences } = useCallCenter()

const deviceId = ref<string>()
const extension = ref<string>()
const devices = ref<MediaDeviceInfo[]>([])

watch(() => props.open, (open) => {
    if (open) init()
})

async function init() {
    devices.value = (await navigator.mediaDevices.enumerateDevices()).filter((device) => device.kind === 'audiooutput' && device.deviceId !== 'default')

    const preferences = getPreferences()
    if (preferences?.ringerDeviceId) {
        deviceId.value = preferences.ringerDeviceId
    }
    if (preferences?.extension) {
        extension.value = preferences.extension
    }
}

async function confirm() {
    updatePreferences({ 
        ringerDeviceId: deviceId.value,
        extension: extension.value
    })

    if (extension.value) {
        fetchExtensionStatus(true)
    }

    dismiss()
}

function dismiss() {
    emit('update:open', false)
}
</script>